import { Controller } from "@hotwired/stimulus"
import InlinePickerController from "./inline_picker_controller"

// Connects to data-controller="compact-picker"
export default class extends InlinePickerController {
  static targets = ['fpField', 'toggle']
  static outlets = ['date-field']

  static values = {
    initial: String
  }

  initFpArea() {
    this.picker = flatpickr(this.element, this.pickerConfig)
  }

  /**
   * The flatpickr config
   * - inline makes the picker always visible
   * - appendTo allows us to choose where the picker is placed in the DOM
   * - positionElement decides where the picker is anchored (can't use hidden field)
   * - onChange allows us to do something when a range is chosen in the picker
   * @returns {object}
   */
  get pickerConfig() {
    return {
      altInput: true,
      inline: false,
      wrap: true,
      altFormat: "m/d/Y",
      dateFormat: "Y-m-d",
      mode: 'single',
      defaultDate: this.dateField.toJSDate,
      positionElement: this.toggleTarget,
      position: "auto center",
      onChange: this.pickerChanged.bind(this)
    }
  }
}
